import React, { useContext, memo } from 'react';
import HashLoader   from "react-spinners/HashLoader";
import { DomainContext } from '../../context/DomainContext';
import './style.css';

const Spinner = () => {
    const { dataLoading } = useContext(DomainContext)

    return (
        <div id={dataLoading ? "spinner" : ""}  >
            <HashLoader  
                size={80}
                color={"#3e5266"}
                loading={dataLoading}
            />
        </div>
    );
} 

export default memo(Spinner);